import React, { ImgHTMLAttributes } from 'react';
import { classNames } from 'primereact/utils';
import bannerSrc from 'assets/mentiway-banner.svg';

export type LogoSize = 'md' | 'lg' | 'xl';

type LogoProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'width' | 'height'> & {
	size: LogoSize;
};

type LogoDimensions = {
	width: number;
	height: number;
};

const sizeMap: Record<LogoSize, LogoDimensions> = {
	md: { width: 128, height: 26 },
	lg: { width: 140, height: 28 },
	xl: { width: 180, height: 36 },
};

export const Logo = ({ size, alt = 'Mentiway', className, ...restProps }: LogoProps) => {
	const { width, height } = sizeMap[size];

	return (
		<img src={bannerSrc} alt={alt} width={width} height={height} className={classNames(className)} {...restProps} />
	);
};
